import { useEffect, useState } from 'react';
import type { InteractiveContent } from '@core-api/presentation/types/response';
import type { ScalesResultForVisualization } from '../types';

export interface IdentitiesListState {
  choiceId: string | null;
  value: number | null;
}

export const useIdentifiedResultsListState = ({
  choices,
  results,
  shouldHideResults,
}: {
  choices: InteractiveContent['choices'];
  results: ScalesResultForVisualization[];
  shouldHideResults: boolean;
}) => {
  const [identitiesListState, setIdentitiesListState] =
    useState<IdentitiesListState>({
      choiceId: null,
      value: null,
    });

  useEffect(() => {
    if (shouldHideResults) {
      setIdentitiesListState({
        choiceId: null,
        value: null,
      });
    }
  }, [shouldHideResults, setIdentitiesListState]);

  const identitiesListChoiceId = identitiesListState.choiceId;
  const identityListChoice = choices.find(
    (c) => c.interactiveContentChoiceId === identitiesListChoiceId,
  );
  const identityListChoiceIndex = choices.findIndex(
    (c) => c.interactiveContentChoiceId === identitiesListChoiceId,
  );

  const activeScaleValueIdentities = results
    ?.find((result) => result.id === identitiesListState.choiceId)
    ?.identifiedResults.find(
      (result) => result.value === identitiesListState.value,
    );

  return {
    identitiesListState,
    setIdentitiesListState,
    identityListChoice,
    identityListChoiceIndex,
    activeScaleValueIdentities,
  };
};
